import React, { useState } from "react";
import { ModalWithIcon } from "../../RfModal/ModalWithIcon";
import { renderPlanColumn } from "../../UpgradeModal/Credits/PlansComparisonCredits";
import { getPlanData, frequencies } from "../../../../../clientServices/workspaceFeaturesCredits";
import { useProjectSelector } from "../../../hooks/useProjectSelector";
import { getTitleForWorkspacePlan } from "../../../../routes/workspace/utils";

export type BasicDowngradePlan = "basic" | "basicAnnual";

type CancelPlanBasicDowngradeModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onCancel: () => void;
    onAcceptBasicPlanDowngrade: (basicDowngradeFrequency: (typeof frequencies)[number]) => void;
    currentPlan: any;
    targetPlan?: "basic" | "core";
};

export function CancelPlanBasicDowngradeModal({
    isOpen,
    onClose,
    onCancel,
    onAcceptBasicPlanDowngrade,
    currentPlan,
    targetPlan = "core"
}: CancelPlanBasicDowngradeModalProps) {
    const [frequency, setFrequency] = useState(frequencies[1]);
    const [loadingAction, setLoadingAction] = useState<string | null>(null);
    const projectSelector = useProjectSelector();

    const planTitle = getTitleForWorkspacePlan(targetPlan);
    const planData = getPlanData(currentPlan, frequency, null, null, projectSelector);
    const targetPlanData = planData[targetPlan];

    const handleAcceptBasicPlanDowngrade = async () => {
        setLoadingAction("downgrade");
        await onAcceptBasicPlanDowngrade(frequency);
        setLoadingAction(null);
    };

    const handleCancel = async () => {
        setLoadingAction("cancel");
        onCancel();
    };

    if (!targetPlanData) {
        return null;
    }

    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            type="warning"
            icon="far fa-arrow-up-arrow-down"
            title={`Instead of canceling, would you like to switch to the ${planTitle}?`}
            cancelButtonText="No Thanks, Cancel Now"
            submitButtonText={`Downgrade to the ${planTitle}`}
            onCancel={handleCancel}
            onSubmit={handleAcceptBasicPlanDowngrade}
            submitButtonProps={{
                disabled: !!loadingAction,
                loading: loadingAction === "downgrade",
                type: "upgrade"
            }}
            cancelButtonProps={{ disabled: !!loadingAction, loading: loadingAction === "cancel" }}
            closeOnCancel={false}
        >
            <div className="mt-1">
                {renderPlanColumn({
                    planKey: targetPlan,
                    planDetails: targetPlanData,
                    getPlanButton: () => {},
                    frequency,
                    setFrequency,
                    recommended: true
                })}
            </div>
        </ModalWithIcon>
    );
}
